export default __webpack_public_path__ + "static/media/spikes.bebc2b26.svg";